var FreeShipping = /** @class */ (function () {
    // private first_order_adjustment_available: boolean;
    // private first_order_adjustment_percent: string;
    function FreeShipping(obj, id) {
        if (id) {
            this.id = id;
        }
        this.free_shipping_for_logged_users = obj.free_shipping_for_logged_users;
        // this.first_order_adjustment_available = obj.first_order_adjustment_available;
        // this.first_order_adjustment_percent = obj.first_order_adjustment_percent;
    }
    Object.defineProperty(FreeShipping.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FreeShipping.prototype, "FreeShippingActive", {
        get: function () {
            return this.free_shipping_for_logged_users;
        },
        enumerable: false,
        configurable: true
    });
    return FreeShipping;
}());
export { FreeShipping };
export function createFreeShipping(obj, id) {
    return new FreeShipping(obj, id);
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/deliveryMethod/freeShipping.ts
// module id = 348
// module chunks = 0